<template>
  <div class="gf-files-list">
    <template v-if="filePath && files && commits">
      <router-link
        class="gf-files-list-item --back"
        tag="div"
        :to="{
          name: 'project-files',
          query: {
            ...(getParentFilePath ? { file: getParentFilePath } : {}),
            ...(commit ? { commit: commit } : {}),
            ...(branch && !commit ? { branch: branch } : {})
          }
        }"
        exact
      >
        <div
          class="gf-files-list-item__cell"
          data-cell-type="back"
        >
          <i class="gf-files-list-item__cell-icon  gf-icon gf-icon-folder" />
          <span class="gf-files-list-item__cell-text text-link">..</span>
        </div>
      </router-link>
    </template>
    <template v-if="files && commits">
      <gf-files-list-item
        v-for="(file, index) in files"
        :key="index"
        :file="file"
        :commit="commits[file?.filename]"
        :has-reload="hasReload"
        :branch-name="branchName"
      />
    </template>
    <template v-else>
      <div class="gf-files-list__preloader">
        <packman-loader
          size="15"
          :style="{ top: '30%' }"
        />
      </div>
    </template>
  </div>
</template>

<script>
import GfFilesListItem from './GfFilesListItem.vue';
import PackmanLoader from './packman-loader.vue';

export default {
  name: 'GfFilesList',
  components: { GfFilesListItem, PackmanLoader },
  props: {
    files: {
      type: Array,
      default() {
        return [];
      }
    },
    commits: {
      type: Object,
      default() {
        return {};
      }
    },
    hasReload: {
      type: Boolean,
      default: false
    },
    // нужен для сохранения выбранной ветки в flth
    branchName: {
      type: String
    }
  },
  computed: {
    branch() {
      return this.$route?.query?.branch || document.getElementById('currentBranch')?.value;
    },
    commit() {
      return this.$route?.query?.commit;
    },
    filePath() {
      return this.$route?.query?.file;
    },
    getParentFilePath() {
      return this.filePath?.substring(0, this.filePath.lastIndexOf('/'));
    }
  }
};
</script>

<style lang="scss">
$this: '.gf-files-list';

#{$this} {
  border: 1px solid var(--border-color);
  border-top: none;
  border-radius: 0 0 var(--border-radius) var(--border-radius);

  #{$this}-item {
    &.--back {
      border-top: none;
    }

    & div[data-cell-type='back'] {
      flex: 1;
      color: var(--gf-folder-c);
      cursor: pointer;
    }
  }
  #{$this}__preloader {
    position: relative;
    height: 36px;
    border-top: 1px solid var(--border-color);
  }
}
</style>
